import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { Router } from '@angular/router';
import { ShareService } from '../../service/share.service';

@Component({
  selector: 'app-b-radio',
  templateUrl: './b-radio.component.html',
  styleUrls: ['./b-radio.component.css']
})
export class BRadioComponent implements OnInit {

  //Component間の共有プロパティ
  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;
  @Output() t_result_listChange = new EventEmitter();

  //textboxに関するMode制御用
  inputFlag: any;
  includeFlag: any;
  MODE: any = Mode;
  Q_TYPE: any = QuestionType;

  constructor(
    private router: Router,
    private shareService: ShareService,
  ) { }

  ngOnInit() {
    //渡されてきたQuestionからプロパティに値を入れる
    this.inputFlag = (this.question.m_question_last_text_input_flg == 1);
    this.includeFlag = (this.question.m_question_last_text_input_include_flg == 1);
  }

  goRegister(question: any): void {
    let categoryInfo = this.shareService.getCategoryInfoShare();
    this.router.navigate(["/question-register/" + categoryInfo["m_question_category_id"] + "/" + question["m_question_id"] + "/" + categoryInfo["m_language_id"] + "/" + question["result_option"]]);
  }

}



// WEBPACK FOOTER //
// ./src/app/parts/b-radio/b-radio.component.ts